<template>
    <div class="editor">
         <div class="ix-comments-loader" v-if="loading">
            <i class="far fa-circle-notch fa-spin"></i> Chargement des données
        </div>
        <quill-editor ref="textEditor" :content="note"  :options="editorOption" @change="onEditorChange($event)" v-if="!loading">
               <div class="output ql-bubble" >
                    <div class="ql-editor" v-html="note"></div>
                </div>
        </quill-editor>
        <div class="editor-update-at">
            <span class="ix-text-small ix-text-secondary" v-if="!loadingForm && updated_at != null">Dernière mise à jour le {{ updated_at | formatDate('DD MMMM YYYY à HH:mm') }}</span>
            <span class="ix-text-small ix-text-secondary" v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i> Sauvegarde des modifications</span>
        </div>
    </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import debounce from 'lodash/debounce';
import MagicUrl from 'quill-magic-url';
import Quill from 'quill'

Quill.register('modules/clink', (quill) => {
    let currentLink = null;
    quill.container.addEventListener('mouseover', (evt) => {
        if (evt.target.tagName === 'A') {
            currentLink = evt.target;
            currentLink.setAttribute('contenteditable', false);
        } else if (currentLink) {
            currentLink.removeAttribute('contenteditable');
            currentLink = null;
        }
    });
});
Quill.register('modules/magicUrl', MagicUrl)

export default {
    name: "Quicknote",
    components: {quillEditor},
    props: {
        url : String,
    },
    data(){
        return {
            note : '',
            id: null,
            updated_at: null,
            loading: false,
            loadingForm: false,
            editorOption: {
                theme: 'bubble',
                placeholder: "À vous la parole ..",
                modules: {
                    toolbar: [
                        [{ 'header': 
                            [1, 2, 3, false],
                         }],
                        ['bold', 'italic', 'underline'],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        [{ 'align': [] }, { 'color': [] }, { 'background': [] }],
                        ['link', 'clean']
                    ],
                    clink: true,
                    magicUrl: true,
                }
        },
        }
    },
    methods: {
      onEditorChange: debounce(function(value) {
          if(this.note != value.html){
            this.note = value.html
            this.loadingForm = true
            fetch(this.url, {
                ...{
                    method: 'POST'
                },
                ...this.getHttpJsonRequestHeaders(),
                ...{
                    body: JSON.stringify({
                        'content' : this.note,
                        'id'      : this.id ? this.id : null
                    })
                }
            }).then((response) => {
                this.loadingForm = false
                if (response.status == 200) {
                    response.json().then((data) => {
                        if (data) {
                            this.updated_at = data.updated_at;
                        }
                    })
                }
            }).catch((error) => {
                this.loadingForm = false
                console.log(error);
            })
          }
          
      }, 500),
    async getNote(){
        this.loading = true;
        fetch(this.url, {
            ...{
                method: 'GET'
            },
            ...this.getHttpJsonRequestHeaders(),
        }).then((response) => {
                if (response.status == 200) {
                    response.json().then((data) => {
                        if (data) {
                            this.note = data.content;
                            this.id = data.id;
                            this.updated_at = data.updated_at;
                        }
                    })
                }
                this.loading = false;
        }).catch((error) => {
            this.loading = false;
        })
    }

    },
    async mounted(){
        await this.getNote();
    },
  

}
</script>